/* eslint-disable function-paren-newline */
import axios from 'axios';
import { FORM_NAME_ENUMS } from '@shared/variables/form-name.enums';
import helperS from '@shared/services/helper.service';
import qs from 'qs';
import store from '../../store';

let controller = new AbortController();
let blobCall = false;

export default {
  getProjectByUuid(uuid, params) {
    return axios.get(`/api/internal/project/info/${uuid}`, { params }).then((res) => res.data);
  },
  getProjectByAlias(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/info`, { params })
      .then((res) => res.data);
  },
  editRepository(alias, projectAlias, data) {
    return axios.put(`/api/project/${alias}/${projectAlias}/setting`, data, {
      formName: FORM_NAME_ENUMS.PROJECT_BASE_SETTING_FORM
    });
  },
  getLastBranchCommit(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/branch/last-commit`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getFileCommitInfo(alias, projectAlias, commitHash, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/commit/${commitHash}/for-file`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getCommitInfo(alias, projectAlias, commitHash) {
    return axios
        .get(`/api/project/${alias}/${projectAlias}/commit/${commitHash}`)
        .then((res) => res.data)
        .catch((err) => {
          throw err;
        });
  },
  getBranches(alias, projectAlias, params, useStore = true) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/branch`, { params })
      .then((res) => {
        if (store && useStore) store.dispatch('setRefBranches', helperS.parsePagination(res.data));
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  getCommitDiff(alias, projectAlias, commitId) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/commit/${commitId}/file`)
      .then((res) => res.data)
      .then((res) =>
        res.map((item, key) => ({
          ...item,
          isCollapsed: key + 1 > this.maxShownFiles ? true : item.isCollapsed
        }))
      )
      .then((res) => store.dispatch('setBranchDiff', res))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getCommitDiffLines(alias, projectAlias, commitId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/commit/${commitId}/diff`, {
        params
      })
      .then((res) => res.data);
  },
  getMergeRequestDiffLines(alias, projectAlias, commitId, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/branch/compare/file`, { params })
      .then((res) => res.data?.commitBlobModelMap);
  },
  getRepositoryFilesCommits(alias, projectAlias, userAlias, commitId, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/commit/${commitId}/last-for-files`, {
        params
      })
      .then((res) => {
        store.dispatch('addCommitInfo', {
          nodePath: decodeURIComponent(params?.filePath || ''),
          commitInfo: res?.data?.lastFilesCommits
        });
        if (res?.data?.lastTreeCommit) {
          store.dispatch('addLastCommitInNodes', {
            nodePath: decodeURIComponent(params?.filePath || ''),
            lastCommitInfo: res?.data?.lastTreeCommit[Object.keys(res?.data?.lastTreeCommit)[0]]
          });
        }
        return res?.data?.lastFilesCommits;
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getRepositoryFiles(alias, projectAlias, userAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/info/files`, {
        params
      })
      .then((res) => {
        store.dispatch('addNode', {
          nodePath: decodeURIComponent(params?.file || ''),
          childrenNodes: res.data
        });
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getFileBlob(userAlias, projectAlias, params) {
    if (blobCall) {
      controller.abort();
      controller = new AbortController();
      blobCall = false;
    }
    blobCall = true;
    const encodedParams = qs.stringify(params);
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/blob?${encodedParams}`, {
        signal: controller.signal
      })
      .then((res) => {
        store.dispatch('addBlob', {
          blobPath: decodeURIComponent(params?.file || ''),
          blob: res.data
        });
        blobCall = false;
        return res?.data;
      })
      .catch((err) => {
        blobCall = false;
        console.log(err);
        throw err;
      });
  },
  getFileMarkdown(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/blob/parsed-file`, {
        params
      })
      .then((res) => {
        store.dispatch('addMarkdownPreview', {
          blobPath: decodeURIComponent(params?.file || ''),
          markdownPreview: res.data
        });
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getBlobBlame(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/blob/blame`, {
        params
      })
      .then((res) => {
        store.dispatch('addBlame', { blobPath: params?.file || '', blame: res.data });
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getFileSplitBlame(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/branch/blame/file`, {
        params
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getForkStatus(alias, projectAlias, params) {
    return axios
      .get(`/api/project/${alias}/${projectAlias}/fork/status`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  fetchFork(alias, projectAlias, data, params) {
    return axios
      .post(`/api/project/${alias}/${projectAlias}/fork/sync`, data, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getProjectTags(projectAlias, userAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/tag`, {
        params
      })
      .then((res) => helperS.parsePagination(res.data))
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getAllowedOwners(params) {
    return axios.get(`/api/project/create/allowed-owners`, { params }).then((res) => res.data);
  },
  getAllowedTeamOwners(params) {
    return axios.get(`/api/team/create/allowed-owners`, { params }).then((res) => res.data);
  },
  getAllOwnersForTransfer(userAlias, projectAlias) {
    return axios.get(`/api/project/${userAlias}/${projectAlias}/setting/allowed-owners`).then((res) => {
      return res.data
    });
  },
  getProjectTabs(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/tabs`, { params })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  editProjectTabs(userAlias, projectAlias, tabsArray) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/tabs`, { tabs: tabsArray })
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  resetProjectTabs(userAlias, projectAlias) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/tabs`)
      .then((res) => res.data)
      .catch((err) => {
        console.log(err);
        throw err;
      });
  },
  getRawBlob(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/edit/blob/raw`, {
        params
      })
      .then((res) => res.data)
      .catch((err) => {
        throw err;
      });
  },
  getBlobAndBranchPermissions(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/edit/permission`, {
        params
      })
      .then((res) => {
        store.dispatch('addBranchPermissions', {
          branch: params?.branch || '',
          permissions: res.data
        });
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  editFile(userAlias, projectAlias, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/edit/blob/edit`, params, {
        formName: FORM_NAME_ENUMS.COMMIT_CREATE_FORM
      })
      .then(() => params)
      .catch((err) => {
        throw err;
      });
  },
  deleteFile(userAlias, projectAlias, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/edit/blob/delete`, params, {
        formName: FORM_NAME_ENUMS.DELETE_FILE_FORM
      })
      .then((res) => ({ params, redirectUrl: res?.data?.redirectUrl }))
      .catch((err) => {
        throw err;
      });
  },
  uploadFiles(userAlias, projectAlias, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/edit/blob/create`, params, {
        formName: FORM_NAME_ENUMS.UPLOAD_FILES_FORM,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(() => {
        const parsedOptions = {};
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of params.entries()) {
          if (key !== 'files') parsedOptions[key] = value;
        }
        return parsedOptions;
      })
      .catch((err) => {
        throw err;
      });
  },
  deleteDirectory(userAlias, projectAlias, params) {
    return axios
      .post(`/api/project/${userAlias}/${projectAlias}/edit/tree/delete`, params, {
        formName: FORM_NAME_ENUMS.DELETE_DIRECTORY_FORM
      })
      .then((res) => ({ params, redirectUrl: res?.data?.redirectUrl || '' }))
      .catch((err) => {
        throw err;
      });
  },

  getForkProject(userAlias, projectAlias, params) {
    return axios
      .get(`/api/project/${userAlias}/${projectAlias}/reference/fork`, {
        params
      })
      .then((res) => {
        return res
      })
      .catch((err) => {
        throw err
      })
  }
};
